import { IPicture } from '@finder/shared/components/picture/picture.interface';

export interface Storycard {
    mainTitle?: string;
    variant?: STORYCARD_VARIANTS;
    sections: StoryCardSection[];
}

export enum STORYCARD_VARIANTS {
    Bullet = 'BULLET',
    Icons = 'ICONS'
}

export interface StoryCardSection {
    title?: string;
    icon?: string;
    image?: IPicture;
    readMoreTitle?: string;
    moreInfo?: boolean;
    copy: Array<string | InterpolationString>;
    key?: string;
    id?: string;
    style?: string;
    titleElement?: HTMLElement;
}

export interface InterpolationString {
    text: string;
    info: LinkInfo[];
}

export interface LinkInfo {
    label: string;
    link?: string;
    title: string;
}
